import { $ as e, $t as t, A as n, At as r, B as i, Bt as a, C as o, Ct as s, D as c, Dt as l, E as u, Et as d, F as f, Ft as p, G as m, Gt as h, H as g, Ht as _, I as ee, It as v, J as y, Jt as te, K as ne, Kt as re, L as b, Lt as x, M as ie, Mt as ae, N as oe, Nt as se, O as ce, Ot as le, P as ue, Pt as de, Q as fe, Qt as pe, R as me, Rt as he, S as ge, St as _e, T as ve, Tt as ye, U as be, Ut as xe, V as Se, Vt as Ce, W as we, Wt as Te, X as Ee, Xt as De, Y as Oe, Yt as ke, Z as Ae, _ as je, _t as Me, a as Ne, at as Pe, b as Fe, bt as Ie, c as Le, ct as Re, d as ze, dt as Be, et as Ve, f as He, ft as Ue, g as We, gt as Ge, h as Ke, ht as qe, i as Je, it as Ye, j as Xe, jt as Ze, k as Qe, kt as $e, l as et, lt as tt, m as nt, mt as rt, n as it, nt as at, o as ot, ot as st, p as ct, pt as lt, q as ut, qt as dt, r as ft, rt as pt, s as mt, st as ht, t as gt, tt as _t, u as vt, ut as yt, v as bt, vt as xt, w as St, wt as Ct, x as wt, xt as Tt, y as Et, yt as Dt, z as Ot, zt as kt } from "./sdk.gen-DbTlFcay.js";
import { $ as At, A as jt, B as Mt, C as Nt, Ct as Pt, D as Ft, E as It, F as Lt, G as Rt, H as zt, I as Bt, J as Vt, K as Ht, L as Ut, M as Wt, N as Gt, O as Kt, P as qt, Q as Jt, R as Yt, S as Xt, St as Zt, T as Qt, Tt as $t, U as en, V as tn, W as nn, X as rn, Y as an, Z as on, _ as sn, _t as cn, a as ln, at as un, b as dn, bt as fn, c as pn, ct as mn, d as S, dt as hn, et as gn, f as _n, ft as vn, g as yn, gt as bn, h as xn, ht as Sn, i as Cn, it as wn, j as Tn, k as En, l as Dn, lt as On, m as kn, mt as An, n as jn, nt as Mn, ot as Nn, p as Pn, pt as Fn, q as In, r as Ln, rt as Rn, st as zn, t as Bn, tt as Vn, u as Hn, ut as Un, v as Wn, vt as Gn, w as Kn, wt as qn, x as Jn, xt as Yn, y as Xn, yt as Zn, z as Qn } from "./shippablePackages-C1gHeo9V.js";
import { t as $n } from "./useOrderService-DO64DKmH.js";
//#region \0rolldown/runtime.js
var er = Object.defineProperty, tr = /* @__PURE__ */ ((e, t) => {
	let n = {};
	for (var r in e) er(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || er(n, Symbol.toStringTag, { value: "Module" }), n;
})({}), nr = (e, t) => {
	let n = e.message;
	if (n) switch (n.case) {
		case ln.OrderCreated:
			t.onCreated?.(n.value);
			break;
		case ln.OrderUpdated:
			t.onUpdated?.(n.value);
			break;
		case ln.OrderDeleted:
			t.onDeleted?.(n.value);
			break;
	}
}, rr = {
	CommercialGoods: "COMMERCIAL_GOODS",
	CommercialSample: "COMMERCIAL_SAMPLE",
	Documents: "DOCUMENTS",
	Gift: "GIFT",
	ReturnedGoods: "RETURNED_GOODS"
}, ir = {
	PickingAndPacking: "PICKING_AND_PACKING",
	Discpatching: "DISPATCHING",
	Untraceable: "UNTRACEABLE",
	Sorting: "SORTING",
	Distributing: "DISTRIBUTING",
	Delivered: "DELIVERED"
}, ar = (e) => e.type === "BUSINESS" || "company" in e && typeof e.company == "string" && e.company.length > 0, or = (e) => e.type === "PRIVATE" || "name" in e && typeof e.name == "string";
//#endregion
//#region src/typeguards/label.ts
function sr(e) {
	return e !== void 0 && "barcode" in e;
}
function cr(e) {
	return e !== void 0 && !("barcode" in e);
}
//#endregion
//#region ../../libs/types/dist/index.js
var C = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18
}, w = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE"
};
C.Dhl, C.Instabox, C.PostNl, w.PostNl, C.Bpost, w.Bpost, C.CheapCargo, w.CheapCargo, C.Dpd, w.Dpd, C.Instabox, w.Instabox, C.Dhl, w.Dhl, C.Bol, w.Bol, C.Ups, w.Ups, C.DhlForYou, w.DhlForYou, C.DhlParcelConnect, w.DhlParcelConnect, C.DhlEuroPlus, w.DhlEuroPlus, C.UpsStandard, w.UpsStandard, C.UpsExpressSaver, w.UpsExpressSaver, C.Gls, w.Gls, C.Brt, w.Brt, C.Trunkrs, w.Trunkrs, C.InPost, w.InPost, C.PosteItaliane, w.PosteItaliane, C.PostNl, w.POSTNL, C.Bpost, w.BPOST, C.CheapCargo, w.CHEAP_CARGO, C.Dpd, w.DPD, C.Instabox, w.INSTABOX, C.Dhl, w.DHL, C.Bol, w.BOL, C.Ups, w.UPS, C.DhlForYou, w.DHL_FOR_YOU, C.DhlParcelConnect, w.DHL_PARCEL_CONNECT, C.DhlEuroPlus, w.DHL_EUROPLUS, C.UpsStandard, w.UPS_STANDARD, C.UpsExpressSaver, w.UPS_EXPRESS_SAVER, C.Gls, w.GLS, C.Brt, w.BRT, C.Trunkrs, w.TRUNKRS, C.InPost, w.INPOST, C.PosteItaliane, w.POSTE_ITALIANE, w.PostNl, C.PostNl, w.POSTNL, C.PostNl, w.Bpost, C.Bpost, w.BPOST, C.Bpost, w.CheapCargo, C.CheapCargo, w.CHEAP_CARGO, C.CheapCargo, w.Dpd, C.Dpd, w.DPD, C.Dpd, w.Instabox, C.Instabox, w.Dhl, C.Dhl, w.BolCom, C.Bol, w.Bol, C.Bol, w.BOL, C.Bol, w.Ups, C.Ups, w.DhlForYou, C.DhlForYou, w.DHL_FOR_YOU, C.DhlForYou, w.DhlParcelConnect, C.DhlParcelConnect, w.DHL_PARCEL_CONNECT, C.DhlParcelConnect, w.DhlEuroPlus, C.DhlEuroPlus, w.DHL_EUROPLUS, C.DhlEuroPlus, w.UpsStandard, C.UpsStandard, w.UPS_STANDARD, C.UpsStandard, w.UpsExpressSaver, C.UpsExpressSaver, w.UPS_EXPRESS_SAVER, C.UpsExpressSaver, w.Gls, C.Gls, w.GLS, C.Gls, w.Brt, C.Brt, w.BRT, C.Brt, w.Trunkrs, C.Trunkrs, w.TRUNKRS, C.Trunkrs, w.InPost, C.InPost, w.INPOST, C.InPost, w.PosteItaliane, C.PosteItaliane, w.POSTE_ITALIANE, C.PosteItaliane;
var T = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
T.Austria, T.Belgium, T.Bulgaria, T.Croatia, T.Cyprus, T.CzechRepublic, T.Denmark, T.Estonia, T.Finland, T.France, T.Germany, T.Greece, T.Hungary, T.Ireland, T.Italy, T.Latvia, T.Lithuania, T.Luxembourg, T.Malta, T.Netherlands, T.Poland, T.Portugal, T.Romania, T.Slovakia, T.Slovenia, T.Spain, T.Sweden, Object.values(T), T.Angola, T.AntiguaAndBarbuda, T.Aruba, T.Bahamas, T.Belize, T.Benin, T.Bermuda, T.BonaireSintEustatiusAndSaba, T.Botswana, T.BurkinaFaso, T.Burundi, T.Cameroon, T.CanaryIslands, T.CentralAfricanRepublic, T.Comoros, T.CongoBrazzaville, T.CongoKinshasa, T.CoteDIvoire, T.Curacao, T.Djibouti, T.Dominica, T.DutchAntilles, T.EquatorialGuinea, T.Eritrea, T.Fiji, T.Gabon, T.Gambia, T.Ghana, T.Grenada, T.Guyana, T.HongKong, T.Kiribati, T.KoreaPeoplesDemocraticRepublic, T.Macao, T.Malawi, T.Mali, T.Mauritania, T.Nauru, T.Qatar, T.Rwanda, T.SaintKittsAndNevis, T.SaoTomeAndPrincipe, T.Seychelles, T.SierraLeone, T.SintMaarten, T.Suriname, T.SyrianArabRepublic, T.TimorLeste, T.Togo, T.Tonga, T.Tuvalu, T.Uganda, T.UnitedArabEmirates, T.Vanuatu, T.Yemen, T.Zimbabwe, T.Austria, T.Belgium, T.Bulgaria, T.Croatia, T.CzechRepublic, T.Estonia, T.Finland, T.France, T.Germany, T.Greece, T.Hungary, T.Ireland, T.Italy, T.Latvia, T.Lithuania, T.Luxembourg, T.Malta, T.Netherlands, T.Portugal, T.Romania, T.Slovakia, T.Slovenia, T.Spain, T.UnitedKingdom, T.Denmark, T.Germany, T.Sweden;
var E = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, D = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, lr = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
E.EarlyMorning, D.EarlyMorning, E.Morning, D.Morning, E.Standard, D.Standard, E.Evening, D.Evening, E.Pickup, D.Pickup, E.PickupExpress, D.PickupExpress, E.SameDayDelivery, D.SameDayDelivery, E.Express, D.Express, D.EarlyMorning, E.EarlyMorning, D.Morning, E.Morning, D.Standard, E.Standard, D.Evening, E.Evening, D.Pickup, E.Pickup, D.PickupExpress, E.PickupExpress, D.SameDayDelivery, E.SameDayDelivery, D.Express, E.Express, E.EarlyMorning, lr.EarlyMorning, E.Morning, lr.Morning, E.Standard, lr.Standard, E.Evening, lr.Evening, E.Pickup, lr.Pickup, E.PickupExpress, lr.PickupExpress, E.SameDayDelivery, lr.SameDayDelivery, E.Express, lr.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var O = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, k = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
k.Sunday, O.Sunday, k.Monday, O.Monday, k.Tuesday, O.Tuesday, k.Wednesday, O.Wednesday, k.Thursday, O.Thursday, k.Friday, O.Friday, k.Saturday, O.Saturday, O.Sunday, k.Sunday, O.Monday, k.Monday, O.Tuesday, k.Tuesday, O.Wednesday, k.Wednesday, O.Thursday, k.Thursday, O.Friday, k.Friday, O.Saturday, k.Saturday;
var ur = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
ur.Bytes, ur.Kilobytes, ur.Megabytes, ur.Gigabytes, ur.Terabytes;
var dr = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, fr = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
dr.Bol, fr.Bol, dr.Exact, fr.Exact, dr.Amazon, fr.Amazon, dr.Wix, fr.Wix, dr.ExactDe, fr.ExactDe, dr.Etsy, fr.Etsy, fr.Bol, dr.Bol, fr.Exact, dr.Exact, fr.Amazon, dr.Amazon, fr.Wix, dr.Wix, fr.ExactDe, dr.ExactDe, fr.Etsy, dr.Etsy;
var A = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, j = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
A.Unpaid, j.Unpaid, A.Due, j.Due, A.DuePrepayment, j.DuePrepayment, A.Reminder1, j.Reminder1, A.Reminder2, j.Reminder2, A.Dun, j.Dun, A.Collection, j.Collection, A.Instalments, j.Instalments, A.PaymentArrangement, j.PaymentArrangement, A.Dispute, j.Dispute, A.LegalProcedure, j.LegalProcedure, A.Insolvency, j.Insolvency, A.WriteOff, j.WriteOff, A.Pending, j.Pending, A.Cancelled, j.Cancelled, A.Paid, j.Paid, A.PaidOnline, j.PaidOnline, A.PaidAutomatic, j.PaidAutomatic, A.PaidCredit, j.PaidCredit, A.PaidZeroItems, j.PaidZeroItems, A.InvoiceWith0InvoiceItemsPaidZeroBalance, j.PaidZeroBalance, A.Due, A.Reminder1, A.Reminder2, A.Dun, A.Collection, A.Instalments, A.PaymentArrangement, A.Dispute, A.Paid, A.PaidOnline, A.PaidAutomatic, A.PaidCredit, A.PaidZeroItems;
var pr = {
	Gram: "g",
	Kilogram: "kg"
};
pr.Gram, pr.Kilogram;
var mr = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
mr.Millimeter, mr.Centimeter, mr.Meter;
var M = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, N = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, hr = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
hr.Light, N.Light, hr.Start, N.Start, hr.Plus, N.Plus, hr.Premium, N.Premium, hr.Max, N.Max, N.Light, hr.Light, N.Start, hr.Start, N.Plus, hr.Plus, N.Premium, hr.Premium, N.Max, hr.Max;
var gr = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, _r = {
	Start: N.Start,
	Plus: N.Plus,
	Premium: N.Premium,
	Max: N.Max
};
gr.Start, _r.Start, gr.Plus, _r.Plus, gr.Premium, _r.Premium, gr.Max, _r.Max, _r.Start, gr.Start, _r.Plus, gr.Plus, _r.Premium, gr.Premium, _r.Max, gr.Max;
var vr = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, yr = {
	Start: N.Start,
	Plus: N.Plus,
	Premium: N.Premium,
	Max: N.Max
};
vr.Start, yr.Start, vr.Plus, yr.Plus, vr.Premium, yr.Premium, vr.Max, yr.Max, yr.Start, vr.Start, yr.Plus, vr.Plus, yr.Premium, vr.Premium, yr.Max, vr.Max;
var br = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, xr = {
	Light: N.Light,
	Start: N.Start,
	Plus: N.Plus,
	Premium: N.Premium,
	Max: N.Max
};
br.Light, xr.Light, br.Start, xr.Start, br.Plus, xr.Plus, br.Premium, xr.Premium, br.Max, xr.Max, xr.Light, br.Light, xr.Start, br.Start, xr.Plus, br.Plus, xr.Premium, br.Premium, xr.Max, br.Max;
var Sr = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Cr = {
	Start: N.Start,
	Plus: N.Plus,
	Premium: N.Premium,
	Max: N.Max
};
Sr.Start, Cr.Start, Sr.Plus, Cr.Plus, Sr.Premium, Cr.Premium, Sr.Max, Cr.Max, Cr.Start, Sr.Start, Cr.Plus, Sr.Plus, Cr.Premium, Sr.Premium, Cr.Max, Sr.Max;
var P = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, wr = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, F = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
P.MyParcel, wr.MyParcel, P.Flespakket, wr.Flespakket, P.SendMyParcel, wr.SendMyParcel, P.MyParcelIt, wr.MyParcelIt, P.DeliverDutch, wr.DeliverDutch, P.PostNlPlugin, wr.PostNlPlugin, P.MyParcel, F.MyParcelNl, P.Flespakket, F.MyParcelNl, P.SendMyParcel, F.MyParcelBe, P.MyParcelIt, F.MyParcelIt, P.DeliverDutch, F.DeliverDutch, P.PostNlPlugin, F.PostNlPlugin, F.MyParcelNl, P.MyParcel, F.MyParcelBe, P.SendMyParcel, F.MyParcelIt, P.MyParcelIt, F.MyParcelNl, M.HomeCountry, T.Netherlands, M.Eu, M.Row, T.Belgium, F.MyParcelBe, M.HomeCountry, T.Belgium, T.Netherlands, M.Eu, M.Row, F.MyParcelBe, M.HomeCountry, T.Belgium, M.Eu, M.Row, F.MyParcelNl, M.HomeCountry, T.Netherlands, M.Eu, M.Row, F.MyParcelNl, M.HomeCountry, T.Netherlands, T.Belgium, T.Luxembourg, C.Bpost, C.PostNl, C.DhlForYou, C.DhlParcelConnect, C.DhlEuroPlus, C.Ups, C.UpsStandard, C.UpsExpressSaver;
var I = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, L = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
I.Package, L.Package, I.Mailbox, L.Mailbox, I.Letter, L.Letter, I.DigitalStamp, L.DigitalStamp, I.Pallet, L.Pallet, I.PackageSmall, L.PackageSmall, I.Envelope, L.Envelope, L.Package, I.Package, L.Mailbox, I.Mailbox, L.Letter, I.Letter, L.DigitalStamp, I.DigitalStamp, L.Pallet, I.Pallet, L.PackageSmall, I.PackageSmall, L.Envelope, I.Envelope;
var Tr = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
I.Package, Tr.PACKAGE, I.Mailbox, Tr.MAILBOX, I.Letter, Tr.UNFRANKED, I.DigitalStamp, Tr.DIGITAL_STAMP, I.Pallet, Tr.PALLET, I.PackageSmall, Tr.SMALL_PACKAGE, I.Envelope, Tr.ENVELOPE;
var R = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
R.PendingConcept, R.PendingRegistered, R.EnrouteHandedToCarrier, R.EnrouteSorting, R.EnrouteDistribution, R.DeliveredAtCustoms, R.DeliveredAtRecipient, R.DeliveredPackagePickedUp, R.DeliveredReturnShipmentPackagePickedUp, R.DeliveredAtAgreedLocation, R.PrintedLetter, R.PrintedDigitalStamp, R.InactiveConcept, R.InactiveRegistered, R.InactiveEnrouteHandedToCarrier, R.InactiveEnrouteSorting, R.InactiveEnrouteDistribution, R.InactiveEnrouteCustoms, R.InactiveDeliveredAtRecipient, R.InactiveDeliveredReadyForPickup, R.InactiveDeliveredPackagePickedUp;
//#endregion
//#region ../../libs/utils/dist/index.js
var Er = Object.create, Dr = Object.defineProperty, Or = Object.getOwnPropertyDescriptor, kr = Object.getOwnPropertyNames, Ar = Object.getPrototypeOf, jr = Object.prototype.hasOwnProperty, Mr = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Nr = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = kr(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !jr.call(e, s) && s !== n && Dr(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Or(t, s)) || r.enumerable
	});
	return e;
}, Pr = (e, t, n) => (n = e == null ? {} : Er(Ar(e)), Nr(t || !e || !e.__esModule ? Dr(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), z = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18
}, B = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE"
};
z.Dhl, z.Instabox, z.PostNl, B.PostNl, z.Bpost, B.Bpost, z.CheapCargo, B.CheapCargo, z.Dpd, B.Dpd, z.Instabox, B.Instabox, z.Dhl, B.Dhl, z.Bol, B.Bol, z.Ups, B.Ups, z.DhlForYou, B.DhlForYou, z.DhlParcelConnect, B.DhlParcelConnect, z.DhlEuroPlus, B.DhlEuroPlus, z.UpsStandard, B.UpsStandard, z.UpsExpressSaver, B.UpsExpressSaver, z.Gls, B.Gls, z.Brt, B.Brt, z.Trunkrs, B.Trunkrs, z.InPost, B.InPost, z.PosteItaliane, B.PosteItaliane, z.PostNl, B.POSTNL, z.Bpost, B.BPOST, z.CheapCargo, B.CHEAP_CARGO, z.Dpd, B.DPD, z.Instabox, B.INSTABOX, z.Dhl, B.DHL, z.Bol, B.BOL, z.Ups, B.UPS, z.DhlForYou, B.DHL_FOR_YOU, z.DhlParcelConnect, B.DHL_PARCEL_CONNECT, z.DhlEuroPlus, B.DHL_EUROPLUS, z.UpsStandard, B.UPS_STANDARD, z.UpsExpressSaver, B.UPS_EXPRESS_SAVER, z.Gls, B.GLS, z.Brt, B.BRT, z.Trunkrs, B.TRUNKRS, z.InPost, B.INPOST, z.PosteItaliane, B.POSTE_ITALIANE, B.PostNl, z.PostNl, B.POSTNL, z.PostNl, B.Bpost, z.Bpost, B.BPOST, z.Bpost, B.CheapCargo, z.CheapCargo, B.CHEAP_CARGO, z.CheapCargo, B.Dpd, z.Dpd, B.DPD, z.Dpd, B.Instabox, z.Instabox, B.Dhl, z.Dhl, B.BolCom, z.Bol, B.Bol, z.Bol, B.BOL, z.Bol, B.Ups, z.Ups, B.DhlForYou, z.DhlForYou, B.DHL_FOR_YOU, z.DhlForYou, B.DhlParcelConnect, z.DhlParcelConnect, B.DHL_PARCEL_CONNECT, z.DhlParcelConnect, B.DhlEuroPlus, z.DhlEuroPlus, B.DHL_EUROPLUS, z.DhlEuroPlus, B.UpsStandard, z.UpsStandard, B.UPS_STANDARD, z.UpsStandard, B.UpsExpressSaver, z.UpsExpressSaver, B.UPS_EXPRESS_SAVER, z.UpsExpressSaver, B.Gls, z.Gls, B.GLS, z.Gls, B.Brt, z.Brt, B.BRT, z.Brt, B.Trunkrs, z.Trunkrs, B.TRUNKRS, z.Trunkrs, B.InPost, z.InPost, B.INPOST, z.InPost, B.PosteItaliane, z.PosteItaliane, B.POSTE_ITALIANE, z.PosteItaliane;
var V = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
V.Austria, V.Belgium, V.Bulgaria, V.Croatia, V.Cyprus, V.CzechRepublic, V.Denmark, V.Estonia, V.Finland, V.France, V.Germany, V.Greece, V.Hungary, V.Ireland, V.Italy, V.Latvia, V.Lithuania, V.Luxembourg, V.Malta, V.Netherlands, V.Poland, V.Portugal, V.Romania, V.Slovakia, V.Slovenia, V.Spain, V.Sweden, Object.values(V), V.Angola, V.AntiguaAndBarbuda, V.Aruba, V.Bahamas, V.Belize, V.Benin, V.Bermuda, V.BonaireSintEustatiusAndSaba, V.Botswana, V.BurkinaFaso, V.Burundi, V.Cameroon, V.CanaryIslands, V.CentralAfricanRepublic, V.Comoros, V.CongoBrazzaville, V.CongoKinshasa, V.CoteDIvoire, V.Curacao, V.Djibouti, V.Dominica, V.DutchAntilles, V.EquatorialGuinea, V.Eritrea, V.Fiji, V.Gabon, V.Gambia, V.Ghana, V.Grenada, V.Guyana, V.HongKong, V.Kiribati, V.KoreaPeoplesDemocraticRepublic, V.Macao, V.Malawi, V.Mali, V.Mauritania, V.Nauru, V.Qatar, V.Rwanda, V.SaintKittsAndNevis, V.SaoTomeAndPrincipe, V.Seychelles, V.SierraLeone, V.SintMaarten, V.Suriname, V.SyrianArabRepublic, V.TimorLeste, V.Togo, V.Tonga, V.Tuvalu, V.Uganda, V.UnitedArabEmirates, V.Vanuatu, V.Yemen, V.Zimbabwe, V.Austria, V.Belgium, V.Bulgaria, V.Croatia, V.CzechRepublic, V.Estonia, V.Finland, V.France, V.Germany, V.Greece, V.Hungary, V.Ireland, V.Italy, V.Latvia, V.Lithuania, V.Luxembourg, V.Malta, V.Netherlands, V.Portugal, V.Romania, V.Slovakia, V.Slovenia, V.Spain, V.UnitedKingdom, V.Denmark, V.Germany, V.Sweden;
var H = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, U = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, Fr = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
H.EarlyMorning, U.EarlyMorning, H.Morning, U.Morning, H.Standard, U.Standard, H.Evening, U.Evening, H.Pickup, U.Pickup, H.PickupExpress, U.PickupExpress, H.SameDayDelivery, U.SameDayDelivery, H.Express, U.Express, U.EarlyMorning, H.EarlyMorning, U.Morning, H.Morning, U.Standard, H.Standard, U.Evening, H.Evening, U.Pickup, H.Pickup, U.PickupExpress, H.PickupExpress, U.SameDayDelivery, H.SameDayDelivery, U.Express, H.Express, H.EarlyMorning, Fr.EarlyMorning, H.Morning, Fr.Morning, H.Standard, Fr.Standard, H.Evening, Fr.Evening, H.Pickup, Fr.Pickup, H.PickupExpress, Fr.PickupExpress, H.SameDayDelivery, Fr.SameDayDelivery, H.Express, Fr.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var W = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, G = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
G.Sunday, W.Sunday, G.Monday, W.Monday, G.Tuesday, W.Tuesday, G.Wednesday, W.Wednesday, G.Thursday, W.Thursday, G.Friday, W.Friday, G.Saturday, W.Saturday, W.Sunday, G.Sunday, W.Monday, G.Monday, W.Tuesday, G.Tuesday, W.Wednesday, G.Wednesday, W.Thursday, G.Thursday, W.Friday, G.Friday, W.Saturday, G.Saturday;
var Ir = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Ir.Bytes, Ir.Kilobytes, Ir.Megabytes, Ir.Gigabytes, Ir.Terabytes;
var Lr = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Rr = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Lr.Bol, Rr.Bol, Lr.Exact, Rr.Exact, Lr.Amazon, Rr.Amazon, Lr.Wix, Rr.Wix, Lr.ExactDe, Rr.ExactDe, Lr.Etsy, Rr.Etsy, Rr.Bol, Lr.Bol, Rr.Exact, Lr.Exact, Rr.Amazon, Lr.Amazon, Rr.Wix, Lr.Wix, Rr.ExactDe, Lr.ExactDe, Rr.Etsy, Lr.Etsy;
var K = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, q = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
K.Unpaid, q.Unpaid, K.Due, q.Due, K.DuePrepayment, q.DuePrepayment, K.Reminder1, q.Reminder1, K.Reminder2, q.Reminder2, K.Dun, q.Dun, K.Collection, q.Collection, K.Instalments, q.Instalments, K.PaymentArrangement, q.PaymentArrangement, K.Dispute, q.Dispute, K.LegalProcedure, q.LegalProcedure, K.Insolvency, q.Insolvency, K.WriteOff, q.WriteOff, K.Pending, q.Pending, K.Cancelled, q.Cancelled, K.Paid, q.Paid, K.PaidOnline, q.PaidOnline, K.PaidAutomatic, q.PaidAutomatic, K.PaidCredit, q.PaidCredit, K.PaidZeroItems, q.PaidZeroItems, K.InvoiceWith0InvoiceItemsPaidZeroBalance, q.PaidZeroBalance, K.Due, K.Reminder1, K.Reminder2, K.Dun, K.Collection, K.Instalments, K.PaymentArrangement, K.Dispute, K.Paid, K.PaidOnline, K.PaidAutomatic, K.PaidCredit, K.PaidZeroItems;
var zr = {
	Gram: "gram",
	Kilogram: "kilogram"
}, Br = {
	Gram: "g",
	Kilogram: "kg"
}, Vr = {
	[Br.Gram]: 1,
	[Br.Kilogram]: 1e3
}, Hr = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Hr.Millimeter, Hr.Centimeter, Hr.Meter;
var Ur = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, J = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Wr = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Wr.Light, J.Light, Wr.Start, J.Start, Wr.Plus, J.Plus, Wr.Premium, J.Premium, Wr.Max, J.Max, J.Light, Wr.Light, J.Start, Wr.Start, J.Plus, Wr.Plus, J.Premium, Wr.Premium, J.Max, Wr.Max;
var Gr = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Kr = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
Gr.Start, Kr.Start, Gr.Plus, Kr.Plus, Gr.Premium, Kr.Premium, Gr.Max, Kr.Max, Kr.Start, Gr.Start, Kr.Plus, Gr.Plus, Kr.Premium, Gr.Premium, Kr.Max, Gr.Max;
var qr = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Jr = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
qr.Start, Jr.Start, qr.Plus, Jr.Plus, qr.Premium, Jr.Premium, qr.Max, Jr.Max, Jr.Start, qr.Start, Jr.Plus, qr.Plus, Jr.Premium, qr.Premium, Jr.Max, qr.Max;
var Yr = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Xr = {
	Light: J.Light,
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
Yr.Light, Xr.Light, Yr.Start, Xr.Start, Yr.Plus, Xr.Plus, Yr.Premium, Xr.Premium, Yr.Max, Xr.Max, Xr.Light, Yr.Light, Xr.Start, Yr.Start, Xr.Plus, Yr.Plus, Xr.Premium, Yr.Premium, Xr.Max, Yr.Max;
var Zr = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Qr = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
Zr.Start, Qr.Start, Zr.Plus, Qr.Plus, Zr.Premium, Qr.Premium, Zr.Max, Qr.Max, Qr.Start, Zr.Start, Qr.Plus, Zr.Plus, Qr.Premium, Zr.Premium, Qr.Max, Zr.Max;
var Y = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, $r = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, X = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Y.MyParcel, $r.MyParcel, Y.Flespakket, $r.Flespakket, Y.SendMyParcel, $r.SendMyParcel, Y.MyParcelIt, $r.MyParcelIt, Y.DeliverDutch, $r.DeliverDutch, Y.PostNlPlugin, $r.PostNlPlugin, Y.MyParcel, X.MyParcelNl, Y.Flespakket, X.MyParcelNl, Y.SendMyParcel, X.MyParcelBe, Y.MyParcelIt, X.MyParcelIt, Y.DeliverDutch, X.DeliverDutch, Y.PostNlPlugin, X.PostNlPlugin, X.MyParcelNl, Y.MyParcel, X.MyParcelBe, Y.SendMyParcel, X.MyParcelIt, Y.MyParcelIt, X.MyParcelNl, Ur.HomeCountry, V.Netherlands, Ur.Eu, Ur.Row, V.Belgium, X.MyParcelBe, Ur.HomeCountry, V.Belgium, V.Netherlands, Ur.Eu, Ur.Row, X.MyParcelBe, Ur.HomeCountry, V.Belgium, Ur.Eu, Ur.Row, X.MyParcelNl, Ur.HomeCountry, V.Netherlands, Ur.Eu, Ur.Row, X.MyParcelNl, Ur.HomeCountry, V.Netherlands, V.Belgium, V.Luxembourg, z.Bpost, z.PostNl, z.DhlForYou, z.DhlParcelConnect, z.DhlEuroPlus, z.Ups, z.UpsStandard, z.UpsExpressSaver;
var Z = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Q = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Z.Package, Q.Package, Z.Mailbox, Q.Mailbox, Z.Letter, Q.Letter, Z.DigitalStamp, Q.DigitalStamp, Z.Pallet, Q.Pallet, Z.PackageSmall, Q.PackageSmall, Z.Envelope, Q.Envelope, Q.Package, Z.Package, Q.Mailbox, Z.Mailbox, Q.Letter, Z.Letter, Q.DigitalStamp, Z.DigitalStamp, Q.Pallet, Z.Pallet, Q.PackageSmall, Z.PackageSmall, Q.Envelope, Z.Envelope;
var ei = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Z.Package, ei.PACKAGE, Z.Mailbox, ei.MAILBOX, Z.Letter, ei.UNFRANKED, Z.DigitalStamp, ei.DIGITAL_STAMP, Z.Pallet, ei.PALLET, Z.PackageSmall, ei.SMALL_PACKAGE, Z.Envelope, ei.ENVELOPE;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
var ti = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, ee = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, v = "en", y = {};
		y[v] = g;
		var te = "$isDayjsObject", ne = function(e) {
			return e instanceof ie || !(!e || !e[te]);
		}, re = function e(t, n, r) {
			var i;
			if (!t) return v;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				y[a] && (i = a), n && (y[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				y[s] = t, i = s;
			}
			return !r && i && (v = i), i || !r && v;
		}, b = function(e, t) {
			if (ne(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ie(n);
		}, x = ee;
		x.l = re, x.i = ne, x.w = function(e, t) {
			return b(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ie = function() {
			function g(e) {
				this.$L = re(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[te] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (x.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return x;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = b(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return b(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < b(e);
			}, _.$g = function(e, t, n) {
				return x.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!x.u(t) || t, u = x.p(e), p = function(e, t) {
					var i = x.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return x.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, ee = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var v = this.$locale().weekStart || 0, y = (h < v ? h + 7 : h) - v;
						return p(r ? _ - y : _ + (6 - y), g);
					case s:
					case f: return m(ee + "Hours", 0);
					case o: return m(ee + "Minutes", 1);
					case a: return m(ee + "Seconds", 2);
					case i: return m(ee + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = x.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[x.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = x.p(u), h = function(e) {
					var t = b(p);
					return x.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return x.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = x.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return x.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return x.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return x.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return x.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return x.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return x.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return x.s(t.$s, 2, "0");
							case "SSS": return x.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = x.p(f), _ = b(r), ee = (_.utcOffset() - this.utcOffset()) * t, v = this - _, y = function() {
					return x.m(h, _);
				};
				switch (g) {
					case d:
						m = y() / 12;
						break;
					case l:
						m = y();
						break;
					case u:
						m = y() / 3;
						break;
					case c:
						m = (v - ee) / 6048e5;
						break;
					case s:
						m = (v - ee) / 864e5;
						break;
					case o:
						m = v / n;
						break;
					case a:
						m = v / t;
						break;
					case i:
						m = v / e;
						break;
					default: m = v;
				}
				return p ? m : x.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return y[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = re(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return x.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ae = ie.prototype;
		return b.prototype = ae, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ae[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), b.extend = function(e, t) {
			return e.$i ||= (e(t, ie, b), !0), b;
		}, b.locale = re, b.isDayjs = ne, b.unix = function(e) {
			return b(1e3 * e);
		}, b.en = y[v], b.Ls = y, b.p = {}, b;
	}));
})), ni = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(ti()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), ri = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(ti()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), ii = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), ai = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal;
				if (this.day = e.match(/\d+/)[0], t) for (var n = 1; n <= 31; n += 1) t(n).replace(/\[|\]/g, "") === e && (this.day = n);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, ee = c || 0, v = l || 0, y = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, ee, v, y + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, ee, v, y)) : new Date(h, g, m, _, ee, v, y);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), oi = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), si = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), ci = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), li = /* @__PURE__ */ Mr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
ni(), ri();
var ui = /* @__PURE__ */ Pr(ti(), 1), di = /* @__PURE__ */ Pr(ii(), 1), fi = /* @__PURE__ */ Pr(ai(), 1), pi = /* @__PURE__ */ Pr(oi(), 1), mi = /* @__PURE__ */ Pr(si(), 1), hi = /* @__PURE__ */ Pr(ci(), 1), gi = /* @__PURE__ */ Pr(li(), 1);
ui.default.extend(fi.default), ui.default.extend(mi.default), ui.default.extend(di.default), ui.default.extend(gi.default), ui.default.extend(pi.default), ui.default.extend(hi.default), ui.default.locale("nl"), ui.default.tz.setDefault("Europe/Amsterdam"), ui.default;
/* c8 ignore start */
var _i = {
	getWeightFactor: (e) => {
		switch (e) {
			case "g":
			case Br.Gram:
			case zr.Gram: return Vr[Br.Gram];
			case Br.Kilogram:
			case zr.Kilogram: return Vr[Br.Kilogram];
			default: throw Error(`Unknown weight unit: ${e}`);
		}
	},
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
}, vi = (e, t) => {
	let n;
	switch (t) {
		case pr.Gram:
			n = e;
			break;
		default:
			n = _i.getWeightFactor(t) * e;
			break;
	}
	return {
		value: n,
		unit: "GRAM"
	};
}, yi = (e) => {
	switch (e.unit) {
		case "GRAM":
		case "g": return e.value;
		case "kg": return e.value * _i.getWeightFactor("kg");
		default: return e.value;
	}
}, bi = [
	S.EVENING_DELIVERY,
	S.EARLY_MORNING_DELIVERY,
	S.MORNING_DELIVERY,
	S.STANDARD_DELIVERY
], xi = {
	[D.EarlyMorning]: S.EARLY_MORNING_DELIVERY,
	[D.Morning]: S.MORNING_DELIVERY,
	[D.Standard]: S.STANDARD_DELIVERY,
	[D.Evening]: S.EVENING_DELIVERY,
	[D.SameDayDelivery]: S.SAME_DAY_DELIVERY,
	[D.Express]: S.EXPRESS_DELIVERY,
	[D.Pickup]: S.PICKUP_DELIVERY,
	[D.PickupExpress]: S.PICKUP_EXPRESS_DELIVERY
}, Si = {
	[S.EARLY_MORNING_DELIVERY]: D.EarlyMorning,
	[S.MORNING_DELIVERY]: D.Morning,
	[S.STANDARD_DELIVERY]: D.Standard,
	[S.EVENING_DELIVERY]: D.Evening,
	[S.SAME_DAY_DELIVERY]: D.SameDayDelivery,
	[S.EXPRESS_DELIVERY]: D.Express,
	[S.PICKUP_DELIVERY]: D.Pickup,
	[S.PICKUP_EXPRESS_DELIVERY]: D.PickupExpress
}, Ci = (e) => Si[e], wi = (e) => xi[e], Ti = [S.PICKUP_DELIVERY, S.PICKUP_EXPRESS_DELIVERY], Ei = (e) => bi.includes(e), Di = (e) => Ti.includes(e), Oi = Object.values(Pn).filter((e) => e !== Pn.DISCOVERED), ki = (e) => e === Pn.DISCOVERED || e === Pn.IMPORT_REQUESTED, Ai = Object.values(Pn).filter((e) => !ki(e)), ji = (e) => e === Pn.CANCELED, Mi = (e) => e === Pn.IMPORT_REQUESTED;
//#endregion
export { bi as ADJUSTED_DELIVERY_TYPES, Ti as ADJUSTED_PICKUP_TYPES, Wn as AddPackagesSchema, Xn as AddressSchema, pn as Aggregation, dn as AggregationSchema, Jn as BillingDetailsSchema, Dn as Carrier, Xt as CarrierSchema, Hn as CarrierToCreate, Nt as CarrierToCreateSchema, Kn as ContactBusinessSchema, Qt as ContactMultiEmailBusinessSchema, It as ContactMultiEmailPrivateSchema, Ft as ContactMultiEmailSchema, Kt as ContactPrivateSchema, En as ContactSchema, jt as CountryCodeSchema, Tn as CreateOrderFromShippablePackagesSchema, Wt as CustomerReferenceSchema, rr as CustomsDeclarationPurpose, Gt as CustomsDeclarationResponseSchema, qt as CustomsDeclarationSchema, Lt as DeliveryOptionsSchema, Bt as DeliverySchema, S as DeliveryType, Ut as DeliveryTypeSchema, Yt as DropOffSchema, Qn as ExternalReferenceEcommercePlatformSchema, Mt as ExternalReferenceSalesChannelSchema, tn as ExternalReferencesMyParcelShopSchema, zt as ExternalReferencesSalesChannelSchema, en as ExternalReferencesSchema, _n as GeoAreaCode, nn as GeoAreaCodeSchema, Rt as LabelWithBarcodeSchema, Ht as LabelWithoutBarcodeSchema, In as LineExternalReferenceSchema, Vt as LineSchema, an as MoneySchema, rn as NoteFromImportedSchema, on as NoteFromPrincipalSchema, Jt as NoteSchema, At as OrderSchema, Pn as OrderStatus, gn as OrderStatusSchema, Vn as PackageCommonSchema, Mn as PackageRequestSchema, Rn as PackageResponseSchema, ir as PackageStatusGroup, wn as PackageStatusSchema, kn as PackageType, un as PackageTypeSchema, xn as PaymentStatus, Nn as PaymentStatusSchema, zn as PhysicalPropertiesSchema, mn as PhysicalPropertiesWeightRequiredSchema, On as PickupSchema, Un as PreparePackagesForShipmentPackageSchema, hn as PreparePackagesForShipmentSchema, vn as ProblemDetailsClientSchema, Fn as ProblemDetailsInternalServerErrorSchema, An as ProblemDetailsInvalidRequestSyntaxSchema, Sn as ProblemDetailsSchema, bn as RegionCodeSchema, yn as ShipmentDirection, cn as ShipmentDirectionSchema, Gn as ShipmentOptionsCommonSchema, Zn as ShipmentOptionsPackageSchema, fn as ShipmentOptionsSchema, Yn as ShipmentRequestSchema, Zt as ShipmentSchema, Pt as ShippablePackageSchema, qn as ShippingSchema, sn as SortDirection, $t as SortDirectionSchema, Ai as activeOrderStatuses, Oi as allStatusesExceptDiscovered, xi as deliveryTypeV1ToV2, Si as deliveryTypeV2ToV1, tr as events, gt as getOrders, it as getPackingSlips, ft as getPicklist, Ei as isAdjustedDeliveryType, Di as isAdjustedPickupType, ar as isBusinessContact, Bn as isCreateMulticolloShippablePackage, jn as isCreateShippablePackage, ki as isDiscoverableOrderStatus, sr as isLabelWithBarcode, cr as isLabelWithoutBarcode, ji as isOrderCanceled, Mi as isOrderImportRequested, or as isPrivateContact, Ln as isShipPackagesAsMulticollo, Cn as isShipPackagesRequest, yi as mapServiceWeightToGrams, vi as mapWeightToService, nr as matchOrderEvent, pe as orderApiAcceptanceUrl, t as orderApiUrl, Je as postAddNote, Ne as postAddPackages, ot as postAssignToUser, mt as postCancel, Le as postCreateFromShippablePackages, et as postEditNote, vt as postImport, ze as postPreparePackagesForShipment, He as postRemoveNotes, ct as postUnassignFromUser, nt as postUnpreparePackagesForShipment, Ci as toDeliveryTypeV1, wi as toDeliveryTypeV2, $n as useOrderService, Ke as zAddPackages, We as zAddress, je as zAggregation, bt as zBillingDetails, Et as zCarrier, Fe as zCarrierToCreate, wt as zContact, ge as zContactBusiness, o as zContactMultiEmail, St as zContactMultiEmailBusiness, ve as zContactMultiEmailPrivate, u as zContactPrivate, c as zCountryCode, ce as zCreateOrderFromShippablePackages, Qe as zCustomerReference, n as zCustomsDeclaration, Xe as zCustomsDeclarationResponse, ie as zDelivery, oe as zDeliveryOptions, ue as zDeliveryType, f as zDropOff, ee as zExternalReferenceEcommercePlatform, b as zExternalReferenceSalesChannel, me as zExternalReferences, Ot as zExternalReferencesMyParcelShop, i as zExternalReferencesSalesChannel, Se as zGeoAreaCode, g as zGetOrdersData, be as zGetOrdersResponse, we as zGetPackingSlipsData, m as zGetPackingSlipsResponse, ne as zGetPicklistData, ut as zGetPicklistResponse, y as zLabelWithBarcode, Oe as zLabelWithoutBarcode, Ee as zLine, Ae as zLineExternalReference, fe as zMoney, e as zNote, Ve as zNoteFromImported, _t as zNoteFromPrincipal, at as zOrder, pt as zOrderStatus, Ye as zPackageCommon, Pe as zPackageRequest, st as zPackageResponse, ht as zPackageStatus, Re as zPackageType, tt as zPaymentStatus, yt as zPhysicalProperties, Be as zPhysicalPropertiesWeightRequired, Ue as zPickup, lt as zPostAddNoteData, rt as zPostAddNoteResponse, qe as zPostAddPackagesData, Ge as zPostAddPackagesResponse, Me as zPostAssignToUserData, xt as zPostAssignToUserResponse, Dt as zPostCancelData, Ie as zPostCancelResponse, Tt as zPostCreateFromShippablePackagesData, _e as zPostCreateFromShippablePackagesResponse, s as zPostEditNoteData, Ct as zPostEditNoteResponse, ye as zPostImportData, d as zPostImportResponse, l as zPostPreparePackagesForShipmentData, le as zPostPreparePackagesForShipmentResponse, $e as zPostRemoveNotesData, r as zPostRemoveNotesResponse, Ze as zPostUnassignFromUserData, ae as zPostUnassignFromUserResponse, se as zPostUnpreparePackagesForShipmentData, de as zPostUnpreparePackagesForShipmentResponse, p as zPreparePackagesForShipment, v as zPreparePackagesForShipmentPackage, x as zProblemDetails, he as zProblemDetailsClient, kt as zProblemDetailsInternalServerError, a as zProblemDetailsInvalidRequestSyntax, Ce as zRegionCode, _ as zShipment, xe as zShipmentDirection, Te as zShipmentOptions, h as zShipmentOptionsCommon, re as zShipmentOptionsPackage, dt as zShipmentRequest, te as zShippablePackage, ke as zShipping, De as zSortDirection };
